<template>
  <!-- Modal pour la signature du document -->
  <b-modal 
    @hide="OnCancel()"
    v-model="isVisible" 
    size="xl" 
    centered 
    hide-footer 
    no-close-on-backdrop 
    no-close-on-esc
    :title="$t('SupervisorValidation')">
    <!-- TABULATION POUR LA VALIDATION DES TERMES ET CONDITIONS -->
    <b-col style="height: 60vh; overflow-y: auto;" class="border rounded mb-3">
        <vue-pdf-embed v-if="SignedPdf" :source="SignedPdf" />
    </b-col>
    <PasswordValidation
        @Submit="saveSupervisorSignature"
        @Back="stepIndex--"/>
  </b-modal>
</template>

<script lang="ts">
  /**
   * Composants vue js
   */
  import { Component } from 'vue-property-decorator';

  /**
   * Composant pour l'affichage du pdf
   */
  import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

  /**
   * Traductions
   */
  import locale from '../../locales/SMA.json';

  /**
   * Composants Vee Validate pour valider les formulaires
   */
  import { ValidationProvider } from 'vee-validate';
  import '@/vee-rules';
  
  /**
   * Classe commune à la validation des mandats
   */
  import { CertificateValidation } from './CertificateValidation';

  /**
   * Composant de validation mot de passe
   */
  import PasswordValidation from './PasswordValidation.vue';

  @Component({
    components: { VuePdfEmbed, ValidationProvider, PasswordValidation },
    i18n: { messages: locale }
  })
  /**
   * Composant pour la signature du pdf 
   * Signature faite à partir d'un dessin sur l'interface ou importé par image
   * Validation final par l'entré du mot de passe du compte
   */
  export default class SigningUpCertificateSupervisor extends CertificateValidation {
    
    // --- Logique Signature ---

    /**
     * Lors de l'annulation de la signature
     */
    private OnCancel(){
      this.$emit("cancel");
    }

    /**
     * Lors du montage du composant, création et téléchargement du pdf 
     */
    async mounted(){
      this.init();
    }

    /**
     * Avant destruction du composant
     * Révocation de l'URL du PDF
     */
    beforeDestroy() {
      if (this.SignedPdf) URL.revokeObjectURL(this.SignedPdf);
    }
  }
</script>

<style scoped>
/* Optionnel : pour cacher les onglets si le prop no-nav-style ne suffit pas sur votre version bootstrap-vue */
::v-deep .nav-tabs {
    display: none !important; 
}
</style>